import type { PaymentsFilters } from '../../../data/paymentFilters'
import { SearchInput } from '../../../components/ui/SearchInput'
import { DateRangeButton } from './DateRangeButton'
import { PaymentStatusTabs } from './PaymentStatusTabs'

type PaymentsToolbarProps = {
  filters: PaymentsFilters
  onChange: (filters: PaymentsFilters) => void
}

export const PaymentsToolbar = ({ filters, onChange }: PaymentsToolbarProps) => (
  <div className="flex w-full flex-col gap-[19px]">
    <PaymentStatusTabs
      onChange={(status) => onChange({ ...filters, status })}
      value={filters.status}
    />

    <div className="flex flex-wrap items-center justify-between gap-[12px]">
      <div className="min-w-[240px] flex-[1_1_320px] max-w-[432px]">
        <SearchInput
          height={38}
          label="Search by driver name"
          onChange={(query) => onChange({ ...filters, query })}
          placeholder="Search by driver name..."
          value={filters.query}
        />
      </div>

      <DateRangeButton
        onChange={(rangeId) => onChange({ ...filters, rangeId })}
        value={filters.rangeId}
      />
    </div>
  </div>
)
